module.exports = __webpack_public_path__ + "img/logo.0b6f503f.jpg";